type ImageProps = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  caption?: string;
};

export function Image({ src, alt, width, height, caption }: ImageProps) {
  // Handle relative paths - serve from Hono API that reads from content/docs
  const apiBase = process.env.BUN_PUBLIC_API_URL ?? "";
  const imageSrc = src.startsWith("/") || src.startsWith("http") ? src : `${apiBase}/static/${src}`;

  return (
    <figure className="my-6">
      <div className="relative w-fit max-w-full rounded-lg overflow-hidden border bg-muted">
        <img
          src={imageSrc}
          alt={alt}
          width={width}
          height={height}
          className="block max-w-full h-auto"
        />
      </div>
      {caption && (
        <figcaption className="mt-2 text-center text-sm text-muted-foreground">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
